export function fn () {
  console.log('dep1 fn');
}